import { cn, createBEM } from "@/libs";
import "./index.scss";
import { amountFormat } from "@/utils/tool";
import { AmountWithIcon } from "@/components/AmountWithIcon";
export const BalanceVB = ({
  value
}: {
  value: string;
  data: any;
}) => {
  const b = createBEM('i-balancevb');
  return <div className={cn(b())} data-sentry-component="BalanceVB" data-sentry-source-file="index.tsx">
    <span className={cn(b('text'))}>
      <AmountWithIcon amount={amountFormat(value, {
        places: 2
      })} data-sentry-element="AmountWithIcon" data-sentry-source-file="index.tsx" /></span>
  </div>;
};